import apiProvincesListCall from 'apps/investcore/apiCalls/provinces/list';
import apiCall from 'apps/investcore/apiCalls/districts';
import { DynamicFilterForm, FilterFieldConfig } from 'common/dynamic-filter-form';
import { useFetchApiList } from 'hooks/api';
import { useEffect } from 'react';
import { DetailPage, ListPage } from 'common/ui/admin-CRUD/page';
import { columnsGenerator } from './config';
import ItemDetail from './detail';

const DistrictFilterForm = props => {
  const { data: provinces, load: loadProvinces } = useFetchApiList(apiProvincesListCall, {
    resourceName: 'data',
  });

  useEffect(() => {
    loadProvinces({ address_version: 'v1', page_size: 99 });
  }, []);

  const filterFields: FilterFieldConfig[] = [
    {
      name: 'province_id',
      type: 'select',
      label: 'Province',
      options: (provinces || []).map(p => ({ value: p.id, label: p.name })),
    },
  ];

  return <DynamicFilterForm fields={filterFields} {...props} />;
};

export const DistrictListPage = () => (
  <ListPage
    title="All District"
    description="All districts for old address version"
    apiCall={apiCall}
    columnsGenerator={columnsGenerator}
    FilterForm={DistrictFilterForm}
  />
);

export const DistrictDetailPage = props => (
  <DetailPage
    title="District"
    apiCall={apiCall}
    listUrl={`/admin/districts`}
    ItemDetail={ItemDetail}
    resourceName="data"
    {...props}
  />
);
